import type { Rgba } from "./types";

export function parseHexRgba(raw: string): Rgba {
  const hex = raw.replace(/^#/, "").replace(/^0x/i, "");
  if (hex.length === 6) {
    return {
      r: Number.parseInt(hex.slice(0, 2), 16),
      g: Number.parseInt(hex.slice(2, 4), 16),
      b: Number.parseInt(hex.slice(4, 6), 16),
      a: 255,
    };
  }
  if (hex.length === 8) {
    return {
      r: Number.parseInt(hex.slice(0, 2), 16),
      g: Number.parseInt(hex.slice(2, 4), 16),
      b: Number.parseInt(hex.slice(4, 6), 16),
      a: Number.parseInt(hex.slice(6, 8), 16),
    };
  }
  throw new Error(`Invalid color: ${raw}`);
}

export function channelDelta(a: Rgba, b: Rgba): number {
  return Math.abs(a.r - b.r) + Math.abs(a.g - b.g) + Math.abs(a.b - b.b);
}

export function tintRgba(base: Rgba, tintHex: string | undefined): Rgba {
  if (!tintHex) return base;
  const t = parseHexRgba(tintHex);
  return {
    r: Math.round((base.r * t.r) / 255),
    g: Math.round((base.g * t.g) / 255),
    b: Math.round((base.b * t.b) / 255),
    a: base.a,
  };
}
